export function buildNativeTaskQuery(queryValue, platform, beginTime, endTime) {
  const params = {
    identifier: String(queryValue || "").trim(),
    beginTime,
    endTime
  };
  const normalizedPlatform = Number(platform);
  if (normalizedPlatform === 1 || normalizedPlatform === 2) {
    params.platform = normalizedPlatform;
  }
  return params;
}
